import React from 'react';
import { IAncillary } from '../../../../domain/ancillary/domain/models/IAncillary';
import { stripPriceFromName } from '../../extras/helpers/stripPriceFromName';
import { BookingSummarySection } from './BookingSummarySection';
import { ExtraSummary } from './ExtraSummary';

interface IAncillarySummaryProps {
	ancillary: IAncillary;
}

export const AncillarySummary = ({ ancillary }: IAncillarySummaryProps) => {
	if (!ancillary.price && !ancillary.extras?.length) {
		return null;
	}

	return (
		<>
			{ancillary.price && (
				<BookingSummarySection
					title={stripPriceFromName(ancillary.name)}
					price={ancillary.price}
				/>
			)}
			{ancillary.extras &&
				ancillary.extras.map((extra) => (
					<ExtraSummary key={extra.id} extra={extra} />
				))}
		</>
	);
};
